export const getClientContext = (bankId, userTrackingId) => {
  const context = {
    client: {
      user_tracking_id: userTrackingId,
      app_title: `${bankId} Web`,
      app_package_name: 'WEB',
      app_version_code: navigator.appVersion,
      app_version_name: navigator.appName
    },
    env: {
      platform: 'WEB',
      platform_version: navigator.appVersion || navigator.vendor || window.opera,
      make: navigator.platform || window.opera,
      locale:
        navigator.userLanguage ||
        navigator.language ||
        navigator.browserLanguage ||
        navigator.systemLanguage
    }
  };
  return JSON.stringify(context);
};
